import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { AssignmentEventTypeEnum } from '../../../shared/enums/assignment-event-type.enum';
import { AssignmentStateService } from '../../services/assignment-state.service';
import { AssignmentsFilterStateService } from '../../services/assignments-filter-state.service';
import { AssignmentsFilterModalComponent } from '../assignments-filter-modal/assignments-filter-modal.component';

@Component({
    templateUrl: './past-assignments.component.html',
    styleUrl: './past-assignments.component.scss',
    providers: [AssignmentsFilterStateService]
})
export class PastAssignmentsComponent implements OnInit {
    assignmentEventType = AssignmentEventTypeEnum;

    constructor(
        public assignmentsStateService: AssignmentStateService,
        private assignmentsFilterStateService: AssignmentsFilterStateService,
        private headerStateService: HeaderStateService,
        private bsModalService: BsModalService,
        private translocoService: TranslocoService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.pastAssignmentsTitle'),
            this.translocoService.translate('main.header.pastAssignmentsDescription'),
            '/assignments',
            'fa-solid fa-filter text-primary'
        );
    }

    ngOnInit(): void {
        let currentFilter = this.assignmentsStateService.pastAssignmentsFilterSubject.value;
        this.assignmentsStateService.loadPastAssignments(currentFilter);
        this.registerEvents()
    }

    // Opening the FilterModal
    public openFilterModal(): void {
        let modalRef: BsModalRef = this.bsModalService.show(AssignmentsFilterModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                isFilterForPastAssignmentEnabled: true
            }
        });
        modalRef.content.assignmentsFilterSubject = this.assignmentsStateService.pastAssignmentsFilterSubject;
        modalRef.content.loadSavedFilters();
    }

    // call only once in ngOnInit
    private registerEvents(): void {
        // Opening FilterModal in the Header
        this.headerStateService.getActionClickedEvent().subscribe((x) => {
            this.openFilterModal();
        })

        this.assignmentsFilterStateService.getIsAnyFilterDisplayedEvent().subscribe(x => {
            this.headerStateService.updateIsActiveStatusIndicatorDisplayed(x);
        });
    }
}
